import React from 'react';
import {Outlet} from 'react-router-dom';

import {
    CommentOutlined,
    MessageOutlined,
    PicLeftOutlined,
    PictureOutlined,
    PieChartOutlined,
    RollbackOutlined,
    SendOutlined,
    SettingOutlined,
    TagsOutlined,
    UploadOutlined,
} from '@/icons';
import {isDefaultAuth} from '@/app/AuthUtils';
import AppAuthRoute from 'page/app/AppAuthRoute';
import AppPageWrapper, {AppStoreProvider} from '@/page/app/context';
import RouteRedirect from '@/app/wrapper/RouteRedirect';

import MsgSendPage from '@/page/app/MsgSendPage';
import MsgHistorySendPage from '@/page/app/msg-history/MsgHistorySendPage';
import MsgHistoryReceivedPage from '@/page/app/msg-history/MsgHistoryReceivedPage';
import CommentPage from '@/page/app/CommentPage';

import MediaPage from '@/page/app/MediaPage';
import NewsPage from '@/page/app/MediaPage/pages/NewsPage';
import NewsLinkPage from '@/page/app/MediaPage/pages/NewsLinkPage';
import ImagePage from '@/page/app/MediaPage/pages/ImagePage';
import TextPage from '@/page/app/MediaPage/pages/TextPage';
import VoicePage from '@/page/app/MediaPage/pages/VoicePage';
import VideoPage from '@/page/app/MediaPage/pages/VideoPage';
import FilePage from '@/page/app/MediaPage/pages/FilePage';

import ReportPage from '@/page/app/ReportPage';
import AppTagsPage from '@/page/app/AppTagsPage';
import MsgAutoReply from '@/page/app/MsgAutoReply';
import AppMenusPage from '@/page/app/AppMenusPage';
import AppSettingsPage from '@/page/app/AppSettingsPage';
import ExtraNews from 'page/extra/news';
import AppRoomPage from '@/page/app/AppRoomPage';
import MyIcon from '@/app/MyIcon';

const appMenu = {
    title: '应用管理',
    path: 'apps/:appId',
    element: (
        <AppStoreProvider>
            <AppPageWrapper>
                <Outlet />
            </AppPageWrapper>
        </AppStoreProvider>
    ),

    children: [
        {
            index: true,
            element: <RouteRedirect menuKey="appMenu" />,
        },
        {
            label: '发送消息',
            path: 'msg-send',
            icon: <SendOutlined />,
            element: <MsgSendPage />,
        },
        {
            label: '历史消息',
            key: 'msg-history',
            icon: <MessageOutlined />,
            path: 'msg-history',
            element: <Outlet />,
            hasSubMenu: true,
            children: [
                {
                    label: '已发送消息',
                    path: 'send',
                    element: <MsgHistorySendPage />,
                },
                {
                    label: '已接收消息',
                    path: 'received',
                    element: <MsgHistoryReceivedPage />,
                },
            ],
        },
        {
            label: '留言管理',
            key: 'comment',
            icon: <CommentOutlined />,
            path: 'comments',
            element: <CommentPage />,
        },
        {
            label: '素材管理',
            icon: <PictureOutlined />,
            path: 'media',
            element: <MediaPage />,
            children: [
                {
                    index: true,
                    element: <NewsPage />,
                },
                {
                    path: 'news',
                    element: <NewsPage />,
                },
                {
                    path: 'newslink',
                    element: <NewsLinkPage />,
                },
                {
                    path: 'image',
                    element: <ImagePage />,
                },
                {
                    path: 'text',
                    element: <TextPage />,
                },
                {
                    path: 'voice',
                    element: <VoicePage />,
                },
                {
                    path: 'video',
                    element: <VideoPage />,
                },
                {
                    path: 'file',
                    element: <FilePage />,
                },
            ],
        },
        {
            label: '上传图文',
            path: 'extranews',
            icon: <UploadOutlined />, // authorities: ['global:sys_apptag:r', 'global:sys_apptag:w'],
            element: <ExtraNews />,
        },
        {
            label: '数据统计',
            icon: <PieChartOutlined />,
            path: 'report',
            element: <ReportPage />,
        },
        // isDefaultAuth && {
        //     label: '可用标签',
        //     path: 'tag',
        //     icon: <TagsOutlined />,
        //     element: <AppTagsPage />,
        // },
        {
            label: '自动回复',
            path: 'reply',
            icon: <RollbackOutlined />,
            element: <MsgAutoReply />,
        },
        {
            label: '菜单管理',
            icon: <PicLeftOutlined />,
            needMgr: true,
            path: 'menu',
            element: (
                <AppAuthRoute needMgr>
                    <AppMenusPage />
                </AppAuthRoute>
            ),
        },
        isDefaultAuth && {
            label: '应用设置',
            icon: <SettingOutlined />,
            needMgr: true,
            path: 'settings',
            element: (
                <AppAuthRoute needMgr>
                    <AppSettingsPage />
                </AppAuthRoute>
            ),
        },
        // {
        //     label: '群组创建',
        //     icon: <MyIcon type="icon-kehuqunguanli" />,
        //     path: 'room',
        //     element: <AppRoomPage />,
        // },
    ].filter(Boolean),
};

export default appMenu;
